module.exports = __webpack_public_path__ + "img/default.d71d8ccb.gif";